/* eslint-disable */
import { Injectable } from '@angular/core';
import { LocalStorageService } from './localstorage.service.js';
import { ApplicationProxyService } from '../../shared/services/applicationproxy.service';
import { ApplicationActions } from '../../actions/application.actions';
import { FlowManagerService } from '../../shared/services/flowmanager.service';


@Injectable()
export class StartUpService {
  constructor(ls: LocalStorageService,
    appActions: ApplicationActions,
    appProxy: ApplicationProxyService,
    flowManager: FlowManagerService) {
    this.ls = ls;
    this.appProxy = appProxy;
    this.appActions = appActions;
    this.flowManager = flowManager;
  }

  init() {
    try {
      // We don't need this but before you can delete it the Form Resolver need updating
      // Need to get all the params and create key value obj with them
      let objURL = {};
      window.location.search.replace(
        new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function(a, b, c, d) {
          objURL[b] = d;
      });
      // Need to check for the app type
      let app = objURL.app || 'tks';
      this.flowManager.setAppType(app === 'tka' ? 'tka' : 'tks');

      if (objURL.promo !== undefined) {
        this.flowManager.promoCode = objURL.promo;
      }

      if (objURL.mbsy !== undefined) {
        const rafObject = {
          mbsy: objURL.mbsy,
          mbsy_source: objURL.mbsy_source,
          campaign_id: objURL.campaignid
        }

        this.appActions.setData('ApplicationInformation', rafObject);
      }

      if (objURL.isNativeApp !== undefined) {
        this.appActions.setData('isMobile', true);
      }

    } catch(e) {
      this.flowManager.setAppType('tks');
    }
  }
}
